import { atom } from 'recoil'
import { IUser } from '@/pages/Users/users.types.ts'

interface IUsersState {
  items: IUser[]
}

const usersAtom = atom<IUsersState>({ key: 'users', default: { items: [] } })
export default usersAtom
